<template>
    <header class="header">
        <div class="navbar-fixed">
            <nav class="header-contractor-desktop">
                <div class="container">
                    <a
                        @click="$emit('push-route', { url: 'LandingPage', solo: false })"
                        class="brand-logo-contrator-desktop"
                    >
                        <img :src="logo" alt="Engelink" />
                        <img
                            height="28px"
                            style="margin-left: 15px; border-left: 1px solid #707070; padding-left: 10px"
                            v-if="showPartnerLogo"
                            src="@/assets/images/cipa-logo.svg"
                            alt="Engelink"
                        />
                    </a>
                    <ul class="contractor-menu-top-desktop">
                        <li
                            @click="$emit('push-route', { url: 'ListCompetitions', solo: false })"
                            :class="[{ 'active-link': $route.name === 'ListCompetitions' }]"
                        >
                            <span class="contractor-title-menu">Minhas cotações</span>
                        </li>
                        <li
                            :class="[{ 'active-link': $route.name === 'NetworkSuppliers' }]"
                            @click="$emit('push-route', { url: 'NetworkSuppliers', solo: false })"
                        >
                            <span class="contractor-guest-title-menu supplier-guide-title">Guia de Fornecedores</span>
                        </li>
                        <li @click="$emit('push-route', { url: 'https://condo.news/', solo: true })"
                        >
                            <span class="contractor-guest-title-menu supplier-guide-title">CondoNews</span>
                        </li>
                        <li @click="$emit('push-route', { url: 'https://pages.engelink.com.br/materiais', solo: true })"
                        >
                            <span class="contractor-guest-title-menu supplier-guide-title">Materiais</span>
                        </li>
                        <li
                            @click="$emit('push-route', { url: 'ContactUs', solo: false })"
                            :class="[{ 'active-link': $route.name === 'ContactUs' }]"
                        >
                            <span class="contractor-title-menu">Fale conosco</span>
                        </li>
                        <li
                            v-show="!isCondoAdministrator && !isRequester"
                            @click="$emit('push-route', { url: 'EditProfile', solo: false })"
                            :class="[{ 'active-link': $route.name === 'EditProfile' }]"
                        >
                            <span class="contractor-title-menu">Editar perfil</span>
                        </li>
                        <li
                            v-show="!isCondoAdministrator && !isRequester"
                            @click="$emit('push-route', { url: 'Home', solo: false, queryString: { redirect: false } })"
                            :class="[{ 'active-link': $route.name === 'Home' }]"
                        >
                            <span class="contractor-title-menu">Alterar perfil</span>
                        </li>
                        <li class="logout" @click="$emit('logout')">
                            <span class="contractor-title-menu">Sair</span>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </header>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'HeaderContractorDesktop',
    props: {
        logo: String,
        showPartnerLogo: Boolean
    },
    computed: {
        ...mapState('user', ['user']),
        isCondoAdministrator() {
            return this.user.type ? this.user.type.isCondoAdministrator : false;
        },
        isRequester() {
            return this.user.type ? this.user.type.isRequester : false;
        }
    }
};
</script>

<style>
.header {
    height: 53px;
}

.header-contractor-desktop {
    background-color: #ffffff;
    z-index: 999 !important;
    height: 53px;
    line-height: 53px;
    box-shadow: 0px 3px 6px #00000029;
}

.header-contractor-desktop .container {
    width: 90% !important;
    display: flex;
    justify-content: center;
    justify-items: space-between;
}

.brand-logo-contrator-desktop {
    align-items: center;
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    cursor: pointer;
}
.contractor-menu-top-desktop {
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
}
.contractor-menu-top-desktop li {
    display: inline-block;
    position: relative;
    cursor: pointer;
    font-size: 16px;
    color: #707070;
    margin-left: 24px;
}

.contractor-menu-top-desktop li.active-link {
    color: #000;
    background-color: none;
}

.contractor-menu-top-desktop li:hover {
    transition: 0.3s;
    color: #000;
    /* border-bottom: 1px solid #707070; */
    /* box-shadow: inset 0 -2px 0#707070; */
}

.contractor-menu-top-desktop li.logout:hover:after {
    width: 0%;
}

.contractor-menu-top-desktop li:after,
.contractor-menu-top-desktop li.active-link:after {
    content: '';
    position: relative;
    bottom: 3px;
    height: 4px;
    display: block;
    margin: auto;
    width: 0px;
    background: transparent;
    transition: width 0.3s ease, background-color 0.3s ease;
}
.contractor-menu-top-desktop li:hover:after,
.contractor-menu-top-desktop li.active-link:after {
    width: 100%;
    background: #707070;
}
</style>
